import PaymentInformationModal from './PaymentInformationModal';

const Paywall3Modal = ({
  data,
  hideModal,
}: {
  data?: any;
  hideModal: () => void;
}) => (
  <PaymentInformationModal
    data={{ ...data, paywallVariant: 'paywall3' }}
    hideModal={hideModal}
  />
);

export default Paywall3Modal;
